import axios from 'axios'
import {apiUrl, checkAA, redirectOutside} from './helpers'

export const unPlugin = {
  install (Vue, options) {
    Vue.prototype.checkAccountAccess = async (accountId) => {
      let acc = await this.checkAA(process.env.UNRIVAL_API, accountId)
      return acc
    }
    Vue.prototype.checkFeatureAccess = async (accountId, code) => {
      let acc = await this.checkFeature(process.env.UNRIVAL_API, accountId, code)
      return acc
    }
  },

  async checkAA (apiUrl, accountId) {
    return new Promise((resolve) => {
      axios.get(apiUrl + 'accounts/' + accountId).then(({data}) => {
        resolve(data)
      }).catch((data) => {
        redirectOutside('/')
      })
    })
  },
  async checkFeature (apiUrl, accountId, code) {
    return new Promise((resolve) => {
      axios.get(apiUrl + 'accounts/' + accountId + '/features').then(({data}) => {
        let feat = data.find(feature => feature.code === code)
        if (!feat) {
          redirectOutside('#/dashboard/' + accountId)
        }
        resolve(data)
      }).catch((data) => {
        redirectOutside('#/dashboard/' + accountId)
      })
    })
  }
}




// WEBPACK FOOTER //
// ./src/service/unrival-plugin.js